import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiClock } from 'react-icons/fi';

const TimeSlotSelector = ({ date, type, onSlotSelect, selectedSlot }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!date || !type) return;

    const fetchSlots = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/appointments/available-slots`,
          { params: { date, type } }
        );
        setSlots(response.data.availableSlots || []);
      } catch (err) {
        setError('Errore nel caricamento degli slot');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSlots();
  }, [date, type]);

  // Filtra solo gli slot disponibili
  const availableSlots = slots.filter(slot => slot.available);

  if (!date || !type) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-500 text-center">Seleziona una data e un tipo di prenotazione</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
        <FiClock size={24} className="text-green-600" />
        Seleziona Fascia Oraria
      </h3>
      
      {loading && (
        <div className="text-center py-4">
          <p className="text-blue-600 font-medium">Caricamento fasce orarie...</p>
        </div>
      )}
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
      )}

      {!loading && availableSlots.length === 0 && (
        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded text-center">
          Nessuna fascia oraria disponibile per questa data
        </div>
      )}

      {!loading && availableSlots.length > 0 && (
        <div>
          <select
            value={selectedSlot || ''}
            onChange={(e) => onSlotSelect(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent font-medium"
          >
            <option value="">Scegli una fascia oraria...</option>
            {availableSlots.map((slot, index) => (
              <option key={index} value={slot.time}>
                {slot.time}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default TimeSlotSelector;
